import { transition, } from 'xstate';

import { useStateMachineContext } from 'machines/hooks/useStateMachineContext';
import { getMeta } from 'machines/utils/misc';
import { checkMatchPath } from 'utils/misc';

export const useGetNextRoute = ({ routes }) => {
  const { actor, machine } = useStateMachineContext();
  const state = actor?.getSnapshot();
  const [nextSnapshot] = transition(machine, state, {
    type: 'NEXT'
  });
  const { path: nextPathName } = getMeta(nextSnapshot);

  return routes.find((route) => checkMatchPath(nextPathName, route.path));
}